<template>
  <v-container>
    <v-card color="primary" class="rounded-xxl py-16 px-10">
      <div class="d-flex align-center justify-space-between textColor rounded-lg px-4 py-2">
        <p class="sm-font300-14 primary--text mb-0">تعریف دوره مادر</p>
        <v-icon>mdi-chevron-left</v-icon>
      </div>
      <div class="textColor px-6 py-8 rounded-lg mt-3">
        <v-stepper v-model="courseStep" alt-labels elevation="0">
          <v-stepper-header>
            <v-stepper-step :complete="courseStep === 1" step="" complete-icon="" @click="courseStep = 1">
              اطلاعات دوره
            </v-stepper-step>

            <v-divider></v-divider>

            <v-stepper-step :complete="courseStep === 2" step="" complete-icon="">
              برنامه
            </v-stepper-step>

            <v-divider></v-divider>

            <v-stepper-step :complete="courseStep === 3" step="" complete-icon="">
              حرکت
            </v-stepper-step>
          </v-stepper-header>

          <v-stepper-items>
            <v-stepper-content step="1">
              <Infos :formType="'create'" :contentData="contentData" @nextStep="nextStep" />
            </v-stepper-content>

            <v-stepper-content step="2">
              <Plans @nextStep="nextStep" />
            </v-stepper-content>

            <v-stepper-content step="3">
              <Actions />
            </v-stepper-content>
          </v-stepper-items>
        </v-stepper>
      </div>

    </v-card>
  </v-container>
</template>

<script>
import Plans from "@/components/Courses/Course/forms/additionalCrs/plans.vue";
import Actions from "@/components/Courses/Course/forms/additionalCrs/actions.vue";
import Infos from "@/components/Courses/Course/forms/additionalCrs/infos.vue";

export default {
  name: "createAdditional",
  components: { Actions, Plans, Infos },
  data() {
    return {
      courseStep: 1,
      contentData: {
        course_type: "Online_Offline",
        category: null,
        priority: null,
        capacity: null,
        price: null,
        usd_price: null,
        use_price: false,
        special_price: null,
        foreign_payment_rial_link: null,
        foreign_payment_usd_link: null,
      },
    }
  },
  methods: {
    nextStep(val) {
      this.courseStep = val
    },
  }
}
</script>

<style scoped></style>
